import { MapStyleSchema } from '../../../renderer/src/map-style-contract';
import { CameraPlatformSchema } from '../../../renderer/src/camera-platform-contract';
import { CameraGimbalSchema } from '../../../renderer/src/camera-gimbal-contract';
import { z } from 'zod';
import { PlaceTitleSchema } from '../../../renderer/src/place-title';
import { ExportRangeSchema } from '../../../renderer/src/export-range-contract';
import { CAMERA_DISTANCE_IDS } from '../domain/camera-distance';
import { ROUTE_LINE_STYLE_IDS } from '../../../renderer/src/presets';
import { CameraAngleSchema } from '../../../renderer/src/camera-angle-contract';
import { TrackAppearanceSchema } from '../../../renderer/src/track-appearance-contract';
import type { VideoRequest } from '../services/local-video';

export const LiveCompositionSchema = z.object({
  exportRange: ExportRangeSchema.nullable().optional(),
  placeTitle: PlaceTitleSchema.nullable().optional(),
  cameraStyleVersion: z.union([z.literal(3), z.literal(4)]).default(4),
  cameraStyleId: CameraPlatformSchema, cameraDistanceId: z.enum(CAMERA_DISTANCE_IDS),
  cameraGimbal: CameraGimbalSchema.optional(),
  cameraAngle: CameraAngleSchema.optional(), mapStyleId: MapStyleSchema,
  lineStyleId: z.enum(ROUTE_LINE_STYLE_IDS), trackAppearance: TrackAppearanceSchema.optional(),
  unitSystem: z.enum(['metric', 'imperial']), hidePlaces: z.boolean(),
  terrainExaggeration: z.number().min(1).max(3), durationSeconds: z.int().min(5).max(240),
}).strict();
export type LiveComposition = z.infer<typeof LiveCompositionSchema>;

export function liveComposition(request: VideoRequest): LiveComposition {
  return LiveCompositionSchema.parse({ cameraStyleVersion: request.cameraStyleVersion ?? 4, placeTitle: request.placeTitle ?? null, cameraStyleId: request.camera, cameraDistanceId: request.distance,
    exportRange: request.exportRange ?? null,
    cameraGimbal: request.cameraGimbal, cameraAngle: request.cameraAngle, mapStyleId: request.mapStyle, lineStyleId: request.line,
    trackAppearance: request.trackAppearance, unitSystem: request.unitSystem ?? 'metric', hidePlaces: request.hidePlaces ?? false,
    terrainExaggeration: request.terrainExaggeration ?? 1, durationSeconds: request.durationSeconds });
}
